"use client";
import { useEffect } from "react";

// Landing page (ayrı subdomain) dil seçimini app'e `?lang=tr|en` query'siyle taşır.
// Bu bileşen auth ekranlarında (login/register/consent) o parametreyi okuyup
// NEXT_LOCALE cookie'sine yazar; böylece next-intl doğru dili sunar. Cookie zaten
// aynıysa hiçbir şey yapmaz (reload döngüsü olmaz).
const SUPPORTED = ["en", "tr", "ru"] as const;

export default function LocaleSync() {
  useEffect(() => {
    const url = new URL(window.location.href);
    const lang = url.searchParams.get("lang");
    if (!lang || !SUPPORTED.includes(lang as (typeof SUPPORTED)[number])) return;
    const current = document.cookie.match(/(?:^|; )NEXT_LOCALE=([^;]+)/)?.[1];
    // ?lang yalnızca BAŞLANGIÇ dilini taşır (landing→app). Parametreyi her durumda
    // URL'den temizleriz; böylece kullanıcı buradaki switcher'dan dili değiştirince
    // sonraki reload'da ?lang onu eski değere geri çekmez.
    url.searchParams.delete("lang");
    if (current === lang) {
      window.history.replaceState({}, "", url.toString());
      return;
    }
    document.cookie = `NEXT_LOCALE=${lang}; path=/; max-age=31536000; samesite=lax`;
    window.history.replaceState({}, "", url.toString());
    window.location.reload();
  }, []);
  return null;
}
